import TabList, { TabListProps } from './TabList';

export type { TabListProps };
export default TabList;
